import { ArrowUp, ArrowDown, ChevronsUpDown } from "lucide-react";

export default function SortLabel({ label, active, dir, onClick, testid, className = "" }) {
  const Icon = !active ? ChevronsUpDown : dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onClick}
      className={`inline-flex items-center gap-1 transition-colors ${active ? "text-blue-700" : "text-slate-500 hover:text-slate-700"} ${className}`}
      aria-label={`Ordina per ${label}`}
      title={`Ordina per ${label}`}
    >
      <span className="text-xs font-semibold uppercase tracking-widest">{label}</span>
      <Icon className={`h-3 w-3 flex-shrink-0 ${active ? "opacity-100" : "opacity-40"}`} />
    </button>
  );
}

// Cella di intestazione centrata: etichetta ordinabile + eventuale filtro (children).
export function HeadCell({ label, sortField, sortKey, sortDir, onSort, children }) {
  return (
    <div className="flex items-center justify-center gap-1.5">
      {sortField ? (
        <SortLabel
          label={label}
          active={sortKey === sortField}
          dir={sortDir}
          onClick={() => onSort(sortField)}
          testid={`sort-${sortField}`}
        />
      ) : (
        <span className="text-xs font-semibold uppercase tracking-widest text-slate-500">{label}</span>
      )}
      {children}
    </div>
  );
}
